import {mapGetters} from 'vuex'
export const peopleMixin = {
    computed: {
        ...mapGetters([
            'getInviteStatusTypes',
            'getProtocolStatusTypes',
            'getAgents'
        ]),
        testing: function() {
            return this.getInviteStatusTypes
        }
    },
    methods: {
        peopleInviteStatus: function(agent) {
            let inviteStatus = agent.inviteStatus
            let protocolStatus = agent.protocolStatus

            //agent is OTA -> we show "Connected"
            if(agent.isOTA){
                inviteStatus = 15; // connected
                protocolStatus = 1; // connected
            }


            let output = this.getInviteStatusTypes.filter(statusType => {
                return statusType.id == inviteStatus
            })[0]

            if(inviteStatus == 15 || protocolStatus == 5){ // 5
                return this.peopleProtocolStatus(agent.protocolStatus)
            } else {
                return output
            }
        },
        peopleProtocolStatus: function(inviteStatus) {
            return this.getProtocolStatusTypes.filter(statusType => {
                return statusType.id == inviteStatus
            })[0]
        },
        agentById: function (agentId) {
            let foundAgent = this.getAgents.filter(storedAgent => {
                return storedAgent.id == agentId
            })

            if(foundAgent.length > 0){
                return foundAgent[0]
            } else {
                return null
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/people.js